<template>
  <!-- mode="in-out" -->
  <!-- :appear="true" -->
  <transition
    @enter="onEnter"
    @leave="onLeave"
  >
    <slot />
  </transition>
</template>

<script setup>
import { computed } from 'vue'
import { animate, useReducedMotion } from 'motion-v'

const props = defineProps({
  isFade: { type: Boolean, default: true },
  isVertical: { type: Boolean, default: false },
  isReverse: { type: Boolean, default: false },
  isContinuous: { type: Boolean, default: true },
  isWidth: { type: String, default: null },
  isDisabled: { type: Boolean, default: false },
  duration: { type: Number, default: 0.3 },
  delta: { type: Number, default: 100 }
})

const shouldReduceMotion = useReducedMotion()

const translationEnter = computed(() => {
  const
    dir = props.isReverse ? -1 : 1,
    shift = props.delta * dir,
    val = [props.isVertical ? 0 : shift, props.isVertical ? shift : 0, 0]
  return `translate3d(${val.map(v => v === 0 ? v : `${v}%`).join(', ')})`
})

const translationLeave = computed(() => {
  const
    dir = props.isReverse ? 1 : -1,
    shift = props.delta * dir,
    val = [props.isVertical ? 0 : shift, props.isVertical ? shift : 0, 0]
  return `translate3d(${val.map(v => v === 0 ? v : `${v}%`).join(', ')})`
})

const onEnter = async (el, done) => {
  if (!props.isDisabled) {
    // Reduced motion: no slide/width change, keep only the opacity fade (or nothing).
    if (shouldReduceMotion.value) {
      if (props.isFade) await animate(el, { opacity: [0, 1] }, { duration: props.duration }).finished
      done()
      return
    }
    await animate(
      el,
      {
        opacity: props.isFade ? [0, 1] : null,
        transform: [translationEnter.value, 'translate3d(0, 0, 0)'],
        width: props.isWidth ? ['0', props.isWidth] : []
      },
      { duration: props.duration }
    ).finished
    done()
  }
}

const onLeave = async (el, done) => {
  if (!props.isDisabled) {
    if (shouldReduceMotion.value) {
      if (props.isFade) await animate(el, { opacity: [1, 0] }, { duration: props.duration }).finished
      done()
      return
    }
    await animate(
      el,
      {
        opacity: props.isFade ? [1, 0] : null,
        transform: ['translate3d(0, 0, 0)', props.isContinuous ? translationLeave.value : translationEnter.value],
        width: props.isWidth ? [props.isWidth, '0'] : []
      },
      { duration: props.duration }
    ).finished
    done()
  }
}
</script>
